// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PJ25","title":"styles_title__2L3mG"};